<template>
  <v-container fluid>
    <div class="text-h5">{{ $t("profile.parent.heading") }}</div>
    <v-form class="mt-2" @submit.prevent="submit()">
      <v-container fluid>
        <div class="text-h5">
          {{ $t("profile.parent.interestAreaHeading") }}
        </div>
        <v-container fluid>
          <v-row no-gutters>
            <v-col
              v-for="availableInterestArea in availableInterestAreaList"
              :key="availableInterestArea.value"
              cols="12"
              sm="6"
            >
              <v-checkbox
                v-model="interestAreaList"
                hide-details
                :label="availableInterestArea.text"
                :value="availableInterestArea.value"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-container>
      <v-container class="d-flex mt-4 align-center justify-end">
        <v-btn color="success" x-large type="submit" :disabled="!isChanged">{{
          $t("submit")
        }}</v-btn>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import diff from "deep-diff";
import parentInterestAreaList from "@/domain/parent-interest-area";
import profileApi from "@/api/profile-api";
import metaTag from "@/mixins/metaTag";

export default {
  name: "ParentProfile",
  mixins: [metaTag],
  data() {
    return {
      submitting: false,
      loading: false,
      interestAreaList: [],
      originalInterestAreaList: [],
    };
  },

  computed: {
    availableInterestAreaList() {
      return Object.entries(parentInterestAreaList).map(function ([
        key,
        value,
      ]) {
        return {
          text: this.$t(`parentInterestAreaList.${key}`),
          value: value,
        };
      },
      this);
    },
    changes() {
      let data = {};
      let excludedAttr = [];
      let options = {
        prefilter: function (path, key) {
          return excludedAttr.includes(key);
        },
        normalize: function (path, key, lhs, rhs) {
          if (rhs === "") {
            rhs = null;
          }
          return [lhs, rhs];
        },
      };
      let parentInterestAreaListHaveChanges = false;
      let originalInterestAreaListValue = this.originalInterestAreaList;

      diff.observableDiff(
        this.originalInterestAreaList,
        this.interestAreaList,
        function (d) {
          if (!originalInterestAreaListValue.includes(d.rhs)) {
            parentInterestAreaListHaveChanges = true;
          }
        },
        options
      );

      if (parentInterestAreaListHaveChanges) {
        data["interestAreaList"] = this.interestAreaList;
      }

      return data;
    },
    isChanged() {
      return Object.keys(this.changes).length > 0;
    },
  },

  created() {
    this.loadParent();
  },

  methods: {
    loadParent() {
      this.loading = true;
      profileApi.get("parent").then((response) => {
        let { interestAreaList } = response.data.data;
        this.interestAreaList = interestAreaList;
        this.originalInterestAreaList = JSON.parse(
          JSON.stringify(interestAreaList)
        );
        this.loading = false;
      });
    },

    submit() {
      this.submitting = true;
      profileApi
        .patch("parent", this.changes)
        .then(() => {
          this.loadParent();
          this.$emit("onSuccess", {
            key: "success.parentProfileUpdated",
          });
        })
        .finally(() => (this.submitting = false));
    },
  },
};
</script>
